(() => {
  function enhanceFAQs(root = document) {
    root.querySelectorAll('.product-description-wrapper h2').forEach(heading => {
      if (!/^(frequently asked questions|faqs)\s*$/i.test(heading.textContent.trim())) return;
      let paragraph = heading.nextElementSibling;
      while (paragraph && paragraph.tagName === 'P') {
        const next = paragraph.nextElementSibling;
        const question = paragraph.firstElementChild;
        if (!question || question.tagName !== 'STRONG' || !question.textContent.trim().endsWith('?')) break;
        if (paragraph.firstChild !== question && paragraph.firstChild.textContent.trim()) break;
        const details = document.createElement('details');
        details.className = 'lulu-product-faq';
        const summary = document.createElement('summary');
        summary.textContent = question.textContent;
        const answer = document.createElement('div');
        answer.className = 'lulu-product-faq__answer';
        question.remove();
        while (paragraph.firstChild && (paragraph.firstChild.nodeName === 'BR' || (paragraph.firstChild.nodeType === 3 && !paragraph.firstChild.textContent.trim()))) paragraph.firstChild.remove();
        while (paragraph.firstChild) answer.append(paragraph.firstChild);
        details.append(summary, answer);
        paragraph.replaceWith(details);
        paragraph = next;
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => enhanceFAQs(), { once: true });
  else enhanceFAQs();
  document.addEventListener('shopify:section:load', event => enhanceFAQs(event.target));
})();